
    import {
        faTimes as falTimes,
    } from '@fortawesome/pro-light-svg-icons/faTimes';
    import {
        faSearch as falSearch,
    } from '@fortawesome/pro-light-svg-icons/faSearch';
    import {
        faCheckCircle as fasCheckCircle,
    } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
    import {
        faPlus as fasPlus,
    } from '@fortawesome/pro-solid-svg-icons/faPlus';
    import {
        faSearch as fasSearch,
    } from '@fortawesome/pro-solid-svg-icons/faSearch';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import C1Tag from '@/C1Components/C1Tag.vue';

    export default {
        name: 'C1TypeaheadMultiSelect',

        components: {
            FontAwesomeIcon,
            C1Tag,
        },

        props: {
            isDisabled: {
                type: Boolean,
                default: false,
            },

            labelKey: {
                type: String,
                default: 'label',
            },

            valueKey: {
                type: String,
                default: 'id',
            },

            options: {
                type: Array,
                default: () => [],
            },

            selected: {
                type: Array,
                default: () => [],
            },

            placeholder: {
                type: String,
                default: 'Type something...',
            },

            uppercase: {
                type: Boolean,
                default: false,
            },

            searchMinLength: {
                type: Number,
                default: 3,
            },

            hideInputIcon: {
                type: Boolean,
                default: false,
            },

            hideDropdownAdd: {
                type: Boolean,
                default: false,
            },

            hideSelected: {
                type: Boolean,
                default: false,
            },

            allowNew: {
                type: Boolean,
                default: false,
            },

            isInvalid: {
                type: Boolean,
                default: false,
            },

            noMobileMode: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                search: '',
                arrowCounter: -1,
                isOpen: false,
                isMobileMode: false,
                notFound: false,
                icons: {
                    falTimes,
                    fasCheckCircle,
                    fasPlus,
                    falSearch,
                    fasSearch,
                },
                originalOptions: [],
                mutableOptions: [],
            };
        },

        computed: {
            classList() {
                return [
                    'c1-typeahead-multi-select',
                    this.getMobileClass,
                    this.getUppercaseClass,
                    this.getInvalidClass,
                ];
            },

            getMobileClass() {
                return this.isMobileMode ? 'c1-typeahead-multi-select--mobile' : '';
            },

            getUppercaseClass() {
                return this.uppercase ? 'c1-typeahead-multi-select--uppercase' : '';
            },

            getInvalidClass() {
                return this.isInvalid ? 'is-invalid' : '';
            },

            selectedSorted() {
                const attr = JSON.parse(JSON.stringify(this.selected));
                return attr.sort((a, b) => {
                    if (a[this.labelKey] < b[this.labelKey]) { return -1; }
                    if (a[this.labelKey] > b[this.labelKey]) { return 1; }
                    return 0;
                });
            },
        },

        watch: {
            options() {
                this.cloneOptions();
            },
        },

        created() {
            if (this.options.length) {
                this.cloneOptions();
            }
        },

        mounted() {
            document.addEventListener('click', this.handleClickOutside);
        },

        destroyed() {
            document.removeEventListener('click', this.handleClickOutside);
        },

        methods: {
            setArrowCounter(number) {
                this.arrowCounter = number;
            },

            resetArrowCounter() {
                this.arrowCounter = -1;
            },

            onFocus() {
                if (window.innerWidth < 768 && !this.noMobileMode) {
                    this.activateMobileMode();
                }
            },

            onInput(newValue) {
                this.search = newValue;
                if (newValue.length <= 0) {
                    this.clear();
                    return;
                }

                if (this.searchMinLength === 0) {
                    this.onSearch();
                } else if (newValue.length >= this.searchMinLength) {
                    if (newValue.substring(0, 3) !== this.search.substring(0, 3)) {
                        this.onSearch();
                    } else if (this.originalOptions.length) {
                        this.searchInternally();
                    } else if (newValue.length <= this.searchMinLength) {
                        this.onSearch();
                    } else {
                        this.close();
                    }
                } else {
                    this.close();
                    this.clearOptions();
                }
            },

            onArrowDown() {
                if (this.arrowCounter < this.mutableOptions.length - 1) {
                    this.arrowCounter += 1;
                    this.fixScrolling();
                }
            },

            onArrowUp() {
                if (this.arrowCounter >= 0) {
                    this.arrowCounter -= 1;
                    this.fixScrolling();
                }
            },

            onEnter() {
                let option = this.search;
                if (this.shouldAddNew() && this.arrowCounter === -1) {
                    this.selectValue(option);
                } else {
                    if (this.arrowCounter === -1) {
                        this.arrowCounter = 0;
                    }
                    option = this.options[this.arrowCounter];
                    this.selectOption();
                }
                this.focus();
            },

            keyInputMonitor(event) {
                if (this.search) {
                    if (event.key === 'Tab' || event.key === 'Enter') {
                        event.preventDefault();
                        this.onEnter();
                    }
                }
            },

            selectOption() {
                const selectedOption = this.mutableOptions[this.arrowCounter];
                if (selectedOption && !this.isSelected(selectedOption)) {
                    this.search = selectedOption[this.labelKey];
                    this.emitSelected(selectedOption);
                    this.clear();
                    this.focus();
                }
            },

            selectValue(value) {
                this.emitSelectedValue(value);
                this.clear();
                this.focus();
            },

            emitSelectedValue(value) {
                this.$emit('select', value);
            },

            emitSelected(option) {
                const originalOption = option ? this.options.find(o => o[this.valueKey] === option[this.valueKey]) || {} : {};
                this.$emit('select', originalOption[this.valueKey] ? originalOption : {});
            },
            removeSelected(option) {
                this.$emit('remove', option);
            },
            onEsc() {
                this.clear();
            },

            fixScrolling() {
                if (this.arrowCounter > 0) {
                    this.$refs[`option_${this.arrowCounter}`][0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                }
            },

            cloneOptions() {
                this.originalOptions = JSON.parse(JSON.stringify(this.options));
                this.mutableOptions = JSON.parse(JSON.stringify(this.options));
                this.searchInternally();
            },

            highlightOptions() {
                const search = this.search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const query = new RegExp(search, 'i');
                this.mutableOptions.forEach((o) => {
                    this.$set(o, `${this.labelKey}_highlighted`, o[this.labelKey].replace(query, '<span>$&</span>'));
                });
            },

            getOptionLabel(option) {
                return option[`${this.labelKey}_highlighted`] || option[this.labelKey];
            },

            searchInternally() {
                const search = this.search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

                this.mutableOptions = this.originalOptions.filter(o => o[this.labelKey].toLowerCase().search(search.toLowerCase()) >= 0);
                this.highlightOptions();
                this.isOpen = this.mutableOptions.length || (this.allowNew && !this.ifValueExists(this.search));
                if (this.mutableOptions.length <= 0) {
                    this.notFound = true;
                } else {
                    this.notFound = false;
                }
            },

            ifValueSelected(option) {
                return !!this.selected.find(o => o[this.labelKey].toLowerCase() === option.toLowerCase());
            },

            ifValueExists(option) {
                return !!this.options.find(o => o[this.labelKey].toLowerCase() === option.toLowerCase());
            },

            isSelected(option) {
                return !!this.selected.find(o => o[this.valueKey] === option[this.valueKey]);
            },

            onSearch() {
                let query = this.search;
                if (this.searchMinLength > 0) {
                    query = this.search.substring(0, this.searchMinLength);
                }
                this.$emit('search', query);
            },

            clear() {
                this.search = '';
                this.notFound = false;
                this.clearOptions();
                this.close();
                this.resetArrowCounter();
            },

            clearOptions() {
                this.originalOptions = [];
                this.mutableOptions = [];
            },

            activateMobileMode() {
                this.isMobileMode = true;
                const body = document.getElementsByTagName('body')[0];
                body.classList.add('body--with-fullscreen-component');
                body.classList.add('c1-typeahead-multi-select--mobile-mode');
                if (this.isMobileMode) {
                    setTimeout(() => {
                        window.scrollTo(0, 0);
                    }, 100);
                }
            },

            deactivateMobileMode() {
                this.clearOptions();
                this.isMobileMode = false;
                const body = document.getElementsByTagName('body')[0];
                body.classList.remove('c1-typeahead-multi-select--mobile-mode');
                body.classList.remove('body--with-fullscreen-component');
            },

            shouldAddNew() {
                return this.allowNew && !this.ifValueExists(this.search);
            },

            open() {
                this.isOpen = true;
            },

            close() {
                this.isOpen = false;
            },

            focus() {
                this.$refs.inputSearch.focus();
            },

            handleClickOutside(e) {
                if (!this.$el.contains(e.target)) {
                    this.close();
                }
            },
        },
    };
